export const data = [
  {
    year: '2009',
    Resale: 0,
    'Traditional Thrift & Donation': 10,
    'Fast Fashion': 22
  },
  {
    year: '2019',
    Resale: 7,
    'Traditional Thrift & Donation': 21,
    'Fast Fashion': 36
  },
  {
    year: '2029',
    Resale: 44,
    'Traditional Thrift & Donation': 36,
    'Fast Fashion': 43
  }
];
